import {Box, Divider, Flex, Text} from "@chakra-ui/react";
import {useIntl} from "next-intl";
import React from "react";


function CheckoutItem(props) {
    const intl = useIntl()
    const {
        cartItem
    } = props
    const {cartItemName, categoryItemMaxOccupancy, cartItemPrice, cartItemQuantity, schemaId} = cartItem;

    return (
        <>
            <Flex direction='column' pt={2}>
                <Flex justify='space-between' align='flex-end'>
                    <Flex direction='column'>
                        <Text fontSize='sm' fontWeight="bold">
                            {cartItemQuantity} x {cartItemName}
                        </Text>
                        <Text fontSize='sm'>
                            {`For `}
                            {cartItemQuantity * categoryItemMaxOccupancy}
                            {cartItemQuantity * categoryItemMaxOccupancy > 1 ? ' Guests' : ' Guest'}
                        </Text>
                    </Flex>
                    <Text fontSize='sm'>{intl.formatNumber(cartItemQuantity * cartItemPrice, {
                        style: 'currency',
                        currency: 'USD'
                    })}</Text>
                </Flex>
            </Flex>
            <Box pt={2} pb={2}>
                <Divider variant='dashed' opacity='1'/>
            </Box>
        </>
    )
}

export default CheckoutItem